(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lulab-announcement-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lulab-announcement-slider')) {
    customElements.define('lulab-announcement-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.viewport = this.querySelector('.lulab-announcement__viewport');
        this.track = this.querySelector('.lulab-announcement__track');
        this.source = this.querySelector('[data-announcement-source]');
        this.status = this.querySelector('.lulab-announcement__status');
        if (!this.viewport || !this.track || !this.source || !this.status) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 767px)');
        this.userPaused = false;
        this.focusReading = false;
        this.selectedBlock = null;
        this.inView = true;
        this.manual = true;
        this.scrollingEnabled = false;
        this.pointerGesture = null;
        this.track.querySelectorAll('[data-announcement-clone]').forEach((clone) => clone.remove());
        for (let i = 0; i < 2; i += 1) {
          const clone = this.source.cloneNode(true);
          clone.removeAttribute('data-announcement-source');
          clone.setAttribute('data-announcement-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id], [data-block-id], [data-shopify-editor-block]').forEach((element) => {
            element.removeAttribute('id');
            element.removeAttribute('data-block-id');
            element.removeAttribute('data-shopify-editor-block');
          });
          clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
          this.track.append(clone);
        }
        this.viewport.addEventListener('pointerdown', (event) => {
          this.pointerGesture = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
        }, { signal, passive: true });
        this.viewport.addEventListener('pointermove', (event) => {
          const gesture = this.pointerGesture;
          if (gesture && event.pointerId === gesture.id && Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 8) gesture.moved = true;
        }, { signal, passive: true });
        this.viewport.addEventListener('pointercancel', () => {
          if (this.pointerGesture) this.pointerGesture.moved = true;
        }, { signal, passive: true });
        this.viewport.addEventListener('click', (event) => {
          const dragged = this.pointerGesture?.moved;
          this.pointerGesture = null;
          if (event.target.closest('a')) return;
          if (event.detail > 0 && dragged) return;
          const selection = getSelection();
          if (selection && !selection.isCollapsed && this.viewport.contains(selection.anchorNode)) return;
          this.togglePause();
        }, { signal });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport || event.repeat || (event.key !== 'Enter' && event.key !== ' ')) return;
          if (!this.scrollingEnabled || this.reducedMotion.matches || this.selectedBlock) return;
          event.preventDefault();
          this.togglePause();
        }, { signal });
        this.viewport.addEventListener('focusin', (event) => {
          if (event.target.closest('[data-announcement-clone]') || !event.target.matches(':focus-visible')) return;
          this.focusReading = true;
          this.refresh();
          if (event.target !== this.viewport) this.reveal(event.target);
        }, { signal });
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (signal.aborted || this.contains(document.activeElement)) return;
            this.focusReading = false;
            this.refresh();
          });
        }, { signal });
        this.reducedMotion.addEventListener('change', () => this.refresh(), { signal });
        this.mobile.addEventListener('change', () => this.refresh(), { signal });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        document.addEventListener('shopify:block:select', (event) => {
          if (event.detail?.sectionId !== this.dataset.sectionId && !this.contains(event.target)) return;
          const blockId = String(event.detail?.blockId || '');
          const block = this.source.querySelector('[data-block-id="' + CSS.escape(blockId) + '"]');
          if (!block) return;
          this.selectedBlock = blockId;
          this.refresh();
          this.reveal(block);
        }, { signal });
        document.addEventListener('shopify:block:deselect', (event) => {
          if (event.detail?.sectionId !== this.dataset.sectionId && !this.contains(event.target)) return;
          this.selectedBlock = null;
          this.refresh();
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.scheduleRefresh());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.source);
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.syncPlayback();
        });
        this.intersectionObserver.observe(this);
        document.fonts.ready.then(() => { if (!signal.aborted) this.refresh(); });
        this.dataset.ready = 'true';
        this.refresh();
      }
      scheduleRefresh() {
        if (this.refreshFrame) cancelAnimationFrame(this.refreshFrame);
        this.refreshFrame = requestAnimationFrame(() => {
          this.refreshFrame = null;
          if (this.isConnected && this.controller) this.refresh();
        });
      }
      refresh() {
        if (!this.isConnected || !this.controller) return;
        const viewportWidth = this.viewport.clientWidth;
        this.style.setProperty('--la-viewport-width', Math.ceil(viewportWidth) + 'px');
        const distance = this.source.getBoundingClientRect().width;
        const scrollingMode = this.mobile.matches ? (this.dataset.scrollingMobile || 'always') : (this.dataset.scrollingDesktop || 'overflow');
        this.scrollingEnabled = this.dataset.autoplay === 'true' && viewportWidth > 0 && (scrollingMode === 'always' || (scrollingMode === 'overflow' && distance > viewportWidth + 1));
        const previous = this.manual;
        this.manual = !this.scrollingEnabled || this.reducedMotion.matches || this.focusReading || Boolean(this.selectedBlock);
        this.dataset.manual = String(this.manual);
        if (previous !== this.manual) this.viewport.scrollLeft = 0;
        const configuredSpeed = Number(this.mobile.matches ? this.dataset.speedMobile : this.dataset.speedDesktop);
        const speed = Number.isFinite(configuredSpeed) && configuredSpeed > 0 ? configuredSpeed : 22;
        this.style.setProperty('--la-distance', distance + 'px');
        this.style.setProperty('--la-duration', Math.max(1, distance / speed) + 's');
        this.syncPlayback();
      }
      togglePause() {
        if (!this.scrollingEnabled || this.reducedMotion.matches || this.selectedBlock) return;
        this.userPaused = this.focusReading ? false : !this.userPaused;
        this.focusReading = false;
        this.refresh();
        this.status.textContent = this.userPaused ? this.dataset.labelPaused : this.dataset.labelPlaying;
      }
      syncPlayback() {
        if (!this.controller) return;
        const canToggle = this.scrollingEnabled && !this.reducedMotion.matches && !this.selectedBlock;
        this.dataset.paused = String(this.userPaused);
        this.viewport.setAttribute('aria-label', canToggle ? this.dataset.labelInteract : this.dataset.labelRead);
        if (canToggle) this.viewport.setAttribute('aria-keyshortcuts', 'Enter Space');
        else this.viewport.removeAttribute('aria-keyshortcuts');
        this.style.setProperty('--la-play-state', this.userPaused || document.hidden || !this.inView ? 'paused' : 'running');
      }
      reveal(element) {
        const left = element.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left + this.viewport.scrollLeft;
        this.viewport.scrollTo({ left: Math.max(0, left - 12), behavior: 'instant' });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        if (this.refreshFrame) cancelAnimationFrame(this.refreshFrame);
        this.refreshFrame = null;
        this.track?.querySelectorAll('[data-announcement-clone]').forEach((clone) => clone.remove());
        this.removeAttribute('data-ready');
        this.dataset.manual = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
